export function initA11yTools() {
	
	const a11yBarVisibilityToggle = 'button[aria-controls="accessability-tools"]';
	const a11yCloseBtn = document.querySelector('.accessability-tools__close-button');
	const a11yBar = document.getElementById('accessability-tools');
	
	// Get all button types
	const toggleButtons = document.querySelectorAll('[data-option-toggle]');
	const cyclingButtons = document.querySelectorAll('[data-options]');
	const fontIncreaseBtn = document.querySelector('[data-option-steps="font-size"].accessability-tools__increase-font');
	const fontDecreaseBtn = document.querySelector('[data-option-steps="font-size"].accessability-tools__decrease-font');

	// Track feature states dynamically
	const featureStates = {
		toolbarOpen: false,
	};

	// Track cycling button states (current option index for each)
	const cyclingStates = {};

	// Initialize cycling states
	cyclingButtons.forEach(button => {
		const toolName = button.dataset.a11yTool;
		cyclingStates[toolName] = 0; // Start at first option
	});

	// Utility function to slugify text
	function slugify(text) {
		return text.toLowerCase()
			.replace(/[^\w\s-]/g, '') // Remove special characters
			.replace(/\s+/g, '-') // Replace spaces with dashes
			.trim();
	}

	// Handle Toggle of the toolbar 
	toggleA11yTools(a11yBarVisibilityToggle);

	// Handle close button
	if (a11yCloseBtn) {
		a11yCloseBtn.addEventListener('click', function() {
			const contentId = this.getAttribute('aria-controls');
			const content = document.getElementById(contentId);
			
			// Hide the accessibility bar
			content.setAttribute('aria-hidden', 'true');
			
			// Update button state
			this.setAttribute('aria-expanded', 'false');
			
			// Update all toggle buttons state
			const toggleButtons = document.querySelectorAll('.toggle-a11y-bar');
			if (toggleButtons) {
				toggleButtons.forEach(button => {
					button.setAttribute('aria-expanded', 'false');
					
					// When closing, return focus to the button that was clicked to open the bar
					if (button.classList.contains('last-used-toggle')) {
						button.focus();
						button.classList.remove('last-used-toggle');
					}
				});
			}
			
			// Update toolbar state in preferences
			featureStates.toolbarOpen = false;
			savePreferences();
		});
	}

	// Handle simple toggle buttons (data-option-toggle)
	toggleButtons.forEach(button => {
		button.addEventListener('click', function() {
			const toggleName = this.dataset.optionToggle;
			const isPressed = this.getAttribute('aria-pressed') === 'true';
			const attributeName = `data-${slugify(toggleName)}`;
			
			// Toggle aria-pressed state
			this.setAttribute('aria-pressed', !isPressed);
			
			// Apply or remove the data attribute on the body element
			if (!isPressed) {
				document.body.setAttribute(attributeName, 'true');
				featureStates[slugify(toggleName)] = true;
			} else {
				document.body.removeAttribute(attributeName);
				featureStates[slugify(toggleName)] = false;
			}
			
			// Save preferences
			savePreferences();
		});
	});

	// Handle cycling buttons (data-options)
	cyclingButtons.forEach(button => {
		button.addEventListener('click', function() {
			const toolName = this.dataset.a11yTool;
			const optionsString = this.dataset.options;
			const options = optionsString.split(',').map(option => option.trim());
			const span = this.querySelector('span');
			
			// Get current state and advance to next option
			let currentIndex = cyclingStates[toolName];
			currentIndex = (currentIndex + 1) % options.length;
			cyclingStates[toolName] = currentIndex;
			
			const currentOption = options[currentIndex];
			const slugifiedOption = slugify(currentOption);
			
			// Update button text
			if (span) {
				span.textContent = currentOption;
			}
			
			// Remove any existing data attributes for this tool
			const existingAttributes = Array.from(document.body.attributes)
				.filter(attr => attr.name.startsWith(`data-${toolName.replace('a11y-', '')}`));
			existingAttributes.forEach(attr => {
				document.body.removeAttribute(attr.name);
			});
			
			// Set the new data attribute on body
			const attributeName = `data-${toolName.replace('a11y-', '')}-${slugifiedOption}`;
			document.body.setAttribute(attributeName, 'true');
			
			// Update aria-pressed state
			this.setAttribute('aria-pressed', 'true');
			
			// Save state
			featureStates[toolName] = {
				currentIndex: currentIndex,
				currentOption: currentOption,
			};
			
			savePreferences();
		});
	});

	// Handle font size buttons
	let currentFontSizeIndex = 0;
	const fontSizeSteps = fontIncreaseBtn ? 
		fontIncreaseBtn.dataset.steps.split(',').map(step => parseFloat(step.trim())) : 
		[1.25, 1.5, 1.75, 2];

	if (fontIncreaseBtn) {
		fontIncreaseBtn.addEventListener('click', function() {
			if (currentFontSizeIndex < fontSizeSteps.length) {
				currentFontSizeIndex++;
				updateFontSize();
			}
		});
	}

	if (fontDecreaseBtn) {
		fontDecreaseBtn.addEventListener('click', function() {
			if (currentFontSizeIndex > 0) {
				currentFontSizeIndex--;
				updateFontSize();
			}
		});
	}

	function updateFontSize() {
		if (currentFontSizeIndex === 0) {
			// Reset to default
			document.body.removeAttribute('data-font-size');
			document.documentElement.style.setProperty('--font-size', '');
			featureStates.fontSize = '';
			
			// Update buttons state
			if (fontIncreaseBtn) {
				fontIncreaseBtn.setAttribute('aria-pressed', 'false');
				fontIncreaseBtn.removeAttribute('disabled');
			}
			if (fontDecreaseBtn) {
				fontDecreaseBtn.setAttribute('aria-pressed', 'false');
				fontDecreaseBtn.setAttribute('disabled', '');
			}
		} else {
			// Apply the current step
			const currentSize = fontSizeSteps[currentFontSizeIndex - 1];
			document.body.setAttribute('data-font-size', currentSize);
			document.documentElement.style.setProperty('--font-size', currentSize);
			featureStates.fontSize = currentSize;
			
			// Update increase button state
			if (fontIncreaseBtn) {
				fontIncreaseBtn.setAttribute('aria-pressed', 'true');
				if (currentFontSizeIndex >= fontSizeSteps.length) {
					fontIncreaseBtn.setAttribute('disabled', '');
				} else {
					fontIncreaseBtn.removeAttribute('disabled');
				}
			}
			
			// Update decrease button state
			if (fontDecreaseBtn) {
				fontDecreaseBtn.setAttribute('aria-pressed', 'true');
				fontDecreaseBtn.removeAttribute('disabled');
			}
		}
		
		// Save the changes
		savePreferences();
	}

	// Persist user preferences using localStorage
	function savePreferences() {
		const allStates = {
			...featureStates,
			cyclingStates: cyclingStates,
		};
		localStorage.setItem('a11yPreferences', JSON.stringify(allStates));
	}

	// Load saved preferences on initialization
	function loadPreferences() {
		const savedPrefs = localStorage.getItem('a11yPreferences');
		
		if (savedPrefs) {
			const preferences = JSON.parse(savedPrefs);
			
			// Update feature states
			Object.assign(featureStates, preferences);
			
			// Restore cycling states
			if (preferences.cyclingStates) {
				Object.assign(cyclingStates, preferences.cyclingStates);
				
				// Apply cycling button states
				cyclingButtons.forEach(button => {
					const toolName = button.dataset.a11yTool;
					const optionsString = button.dataset.options;
					const options = optionsString.split(',').map(option => option.trim());
					const span = button.querySelector('span');
					
					if (preferences.cyclingStates[toolName] !== undefined) {
						const currentIndex = preferences.cyclingStates[toolName];
						const currentOption = options[currentIndex];
						const slugifiedOption = slugify(currentOption);
						
						// Update button text
						if (span) {
							span.textContent = currentOption;
						}
						
						// Set data attribute on body
						const attributeName = `data-${toolName.replace('a11y-', '')}-${slugifiedOption}`;
						document.body.setAttribute(attributeName, 'true');
						
						// Update aria-pressed
						button.setAttribute('aria-pressed', 'true');
					}
				});
			}
			
			// Apply toggle button states
			toggleButtons.forEach(button => {
				const toggleName = button.dataset.optionToggle;
				const slugifiedName = slugify(toggleName);
				
				if (preferences[slugifiedName]) {
					const attributeName = `data-${slugifiedName}`;
					document.body.setAttribute(attributeName, 'true');
					button.setAttribute('aria-pressed', 'true');
				}
			});
			
			// Apply font size setting
			if (preferences.fontSize) {
				document.body.setAttribute('data-font-size', preferences.fontSize);
				document.documentElement.style.setProperty('--font-size', preferences.fontSize);
				
				const size = parseFloat(preferences.fontSize);
				currentFontSizeIndex = fontSizeSteps.indexOf(size) + 1;
				
				if (currentFontSizeIndex > 0) {
					if (fontIncreaseBtn) {
						fontIncreaseBtn.setAttribute('aria-pressed', 'true');
						if (currentFontSizeIndex >= fontSizeSteps.length) {
							fontIncreaseBtn.setAttribute('disabled', '');
						}
					}
					
					if (fontDecreaseBtn) {
						fontDecreaseBtn.setAttribute('aria-pressed', 'true');
						fontDecreaseBtn.removeAttribute('disabled');
					}
				}
			}
			
			// Apply saved toolbar state
			if (preferences.toolbarOpen && a11yBar) {
				a11yBar.setAttribute('aria-hidden', 'false');
				
				const toggleButtons = document.querySelectorAll('.toggle-a11y-bar');
				toggleButtons.forEach(button => {
					button.setAttribute('aria-expanded', 'true');
				});
				
				if (a11yCloseBtn) {
					a11yCloseBtn.setAttribute('aria-expanded', 'true');
				}
			}
		}
	}

	// Load preferences on initialization
	loadPreferences();
}

function toggleA11yTools(selector) {
	// Get all accordion triggers
	const accordionTriggers = document.querySelectorAll(selector);
	
	// Function to toggle accordion state
	function toggleAccordion(trigger) {
		// Get the current state
		const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
		
		// Toggle the ARIA expanded state on the button
		trigger.setAttribute('aria-expanded', !isExpanded);
		
		// Find the associated content panel
		const contentId = trigger.getAttribute('aria-controls');
		const content = document.getElementById(contentId);
		
		// Toggle the ARIA hidden state on the content
		content.setAttribute('aria-hidden', isExpanded);
		
		// Update all other trigger buttons with the same aria-controls
		const relatedTriggers = document.querySelectorAll(`[aria-controls='${contentId}']`);
		relatedTriggers.forEach(relatedTrigger => {
			if (relatedTrigger !== trigger) {
				relatedTrigger.setAttribute('aria-expanded', !isExpanded);
			}
		});
		
		// Also update the close button state
		const closeButton = content.querySelector('.accessability-tools__close-button');
		if (closeButton) {
			closeButton.setAttribute('aria-expanded', !isExpanded);
		}
		
		// If opening the accessibility bar, move focus to it and mark the trigger
		if (!isExpanded) {
			// Mark this button as the last one used to open the panel
			// Remove class from all other triggers first
			relatedTriggers.forEach(relatedTrigger => {
				relatedTrigger.classList.remove('last-used-toggle');
			});
			
			// Add class to current trigger
			trigger.classList.add('last-used-toggle');
			
			// Set focus to the first interactive element in the accessibility bar
			// First, make sure it's visible before trying to focus
			setTimeout(() => {
				// Find the first focusable element (typically the first toggle button)
				const firstFocusableElement = content.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
				if (firstFocusableElement) {
					firstFocusableElement.focus();
				}
			}, 50); // Short delay to ensure the element is visible when focus is set
		}
		
		// Save the state to preferences
		const featureStates = JSON.parse(localStorage.getItem('a11yPreferences') || '{}');
		featureStates.toolbarOpen = !isExpanded;
		localStorage.setItem('a11yPreferences', JSON.stringify(featureStates));
	}
	
	// Add click event listeners to each trigger
	accordionTriggers.forEach((trigger) => {
		trigger.addEventListener('click', () => {
			toggleAccordion(trigger);
		});
	});
	
	// Add keyboard navigation
	document.addEventListener('keydown', (event) => {
		// Check if the active element is an accordion trigger
		if (document.activeElement.matches(selector)) {
			const key = event.key;
			
			// Space or Enter key will toggle the accordion
			if (key === ' ' || key === 'Enter') {
				event.preventDefault();
				toggleAccordion(document.activeElement);
			}
		}
	});
}


// WEBPACK FOOTER //
// ./scripts/modules/a11y.js